import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import RichTextSlider from "../../molecules/richtext-slider/richTextSlider";

import "./richtextDescription.scss";

const RichtextDescription = (props: ReferenciaContenido) => {
  const { descripcion } = props;
  const { isBrowser, document } = useBrowserMode();

  const sdkQuery = useStaticQuery(graphql`
    query SDK_LIST {
      allContentfulHome(filter: { titulo: { eq: "Home bibliotecas" } }) {
        nodes {
          listaSdk
        }
      }
    }
  `);

  const sdks = sdkQuery.allContentfulHome.nodes[0].listaSdk;

  const checkSdk = (sdkMatch: any) => {
    if (
      isBrowser &&
      sdks &&
      sdks.filter((sdk: string) => sdkMatch[0].slice(5).includes(sdk))
    ) {
      const sdkScript = document.createElement("script");
      sdkScript.src = sdkMatch[0].slice(5);
      sdkScript.async = true;
      document.body.appendChild(sdkScript);
    }
  };

  const renderEmbeddedAsset = (node: any) => {
    if (node.data.target.fields) {
      return (
        <img
          src={node.data.target.fields.file["en-US"] ?
            node.data.target.fields.file["en-US"].url :
            node.data.target.fields.file.url
          }
          alt={formatImageAlt(node.data.target.fields.title) || "Imagen texto enriquecido"}
        />
      );
    } else {
      return <></>;
    }
  };

  const renderHyperlink = (node: any) => {
    return (
      <a href={node.data.uri} target="_blank" rel="noreferrer">
        {node.content[0].value}
      </a>
    );
  };

  const renderQuote = (node: any) => {
    return (
      <div className="a-richtext-description a-richtext-description__content a-richtext-description__quote">
        <div className="icon-quote-left" />
        <div className="icon-quote-right" />
        <span>{node.content[0].content[0].value}</span>
      </div>
    );
  };

  const renderCode = (text: any) => {
    let embeddedScript: string = "";

    if (text.indexOf("<script") > -1 && text.indexOf("/script>") > -1) {
      embeddedScript = text.slice(
        text.indexOf("<script"),
        text.indexOf("/script>") + 8
      );
      checkSdk(embeddedScript.match(/src=["'][\w/.:]*/g));
    }

    const createMarkup = () => {
      return {
        __html: text.replace(embeddedScript, ""),
      };
    };

    return (
      <object
        className="a-richtext-description a-richtext-description__content a-richtext-description__embed"
        dangerouslySetInnerHTML={createMarkup()}
      />
    );
  };

  const options = {
    renderMark: {
      [MARKS.CODE]: renderCode,
    },
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: renderEmbeddedAsset,
      [BLOCKS.QUOTE]: renderQuote,
      [INLINES.HYPERLINK]: renderHyperlink,
    },
  };

  let isColumns = false;

  for (let i = 0; i < descripcion.json.content.length; i++) {
    if (descripcion.json.content[i].nodeType === "hr") {
      isColumns = true;
      break;
    }
  }

  if (isColumns) {
    let lengthItems = descripcion.json.content.length;
    let items = Array();
    let auxArr = Array();
    let j = 0;

    for (let i = 0; i < lengthItems; i++) {
      if (j < 3) {
        if (descripcion.json.content[i].nodeType !== "hr") {
          auxArr.push(descripcion.json.content[i]);
          j++;
        }
      } else {
        items.push(auxArr);
        auxArr = Array();
        j = 0;
      }
    }

    if (auxArr.length !== 0) items.push(auxArr);

    return (
      <div className="a-richtext-columns">
        <div className="a-richtext-columns__desk">
          {descripcion.json.content.map((elem, idx) => {
            if (elem.nodeType !== "hr") {
              return (
                <div className="a-richtext-columns__desk-item" key={idx}>
                  <p className="icon-circle"></p>
                  <p className="a-richtext-columns__desk-item__text">
                    {elem.content[0].value}
                  </p>
                </div>
              );
            }
          })}
        </div>

        <div className="a-richtext-columns__mobile">
          <RichTextSlider items={items} gtmClass="" />
        </div>
      </div>
    );
  } else {
    return (
      <div className="a-richtext-description a-richtext-description__container">
        <div className="a-richtext-description a-richtext-description__content">
          {documentToReactComponents(descripcion.json, options)}
        </div>
      </div>
    );
  }
};

export default RichtextDescription;
